// import Vue from 'vue'
// import App from './App.vue'
//
// Vue.config.productionTip = false
//
// new Vue({
//   render: h => h(App),
// }).$mount('#app')


import Vue from 'vue'
import App from './App'
import constant from './js/constant'
import router from './js/router.config'
import store from './js/store'
import Utils from './js/utils'
import * as filters from './js/filter'
import VueResource from '../node_modules/vue-resource/dist/vue-resource.min'
import $ from 'jquery'
import './css/common.css'
import './css/login.scss'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueParticles from 'vue-particles'
import md5 from './js/md5.min'
import echarts from 'echarts'

Vue.use(md5);
Vue.use(VueParticles);
Vue.use(ElementUI);
Vue.use(Utils);
Vue.use(constant);
Vue.use(VueResource);
Vue.config.productionTip = false;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})
// Vue.use(store);

Vue.prototype.$store=store;
Vue.prototype.$echarts=echarts;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

Vue.http.interceptors.push(function(request,next) {
  // let hash = 'userId=' + this.$store.state.auth_userId + '&timestamp=' + this.$store.state.auth_timestamp + '&salt=rasberCloud';
  // request.headers.set('auth_userId', this.$store.state.auth_userId);
  // request.headers.set('auth_timestamp', this.$store.state.auth_timestamp);
  // request.headers.set('token', MD5(hash));
  // this.fullscreenLoading = true;
  const loading = this.$loading({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  next(function (response) {
    // this.fullscreenLoading = false;
    loading.close();
    if(response.statusText === 'Unauthorized'
      || response.status === 401
      || response.status === '401' ){
      sessionStorage.clear();
      this.$router.push({ path: '/' });
      this.$store.commit('setToken','');
      localStorage.removeItem('oAuthToken');
      location.reload();
      this.$message("身份验证已过期，请重新登陆");
    }else if(response.status === 502
      || response.status === '502' ){
      this.$message("请检查网络");
    }
    // else if(response.statusText === ''
    //     || response.body.errcode === -1
    //     || response.body.errcode === '-1' ){
    //     this.$message(response.body.msg);
    // }
  })
});
